module.exports = {
  news: require("./news"),
  group: require("./group"),
  backoffice: require("./backoffice"),
  projects: require("./projects"),
  settings: require("./settings"),
  steps: require("./steps"),
  toolbar: require("./toolbar")
};
